import { render, staticRenderFns } from "./home-graph-caption-list.component.vue?vue&type=template&id=00a4af10&scoped=true&"
import script from "./home-graph-caption-list.component.vue?vue&type=script&lang=ts&"
export * from "./home-graph-caption-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./home-graph-caption-list.component.vue?vue&type=style&index=0&id=00a4af10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4af10",
  null
  
)

export default component.exports